import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import "./styles.scss";
import axios from "axios";
import { useDispatch } from "react-redux";

import WhatIsCitiis from "./components/whatIsCitiis";
import OurWork from "./components/ourWork";
import CitiisDifferent from "./components/citiisDifferent";
import OurResources from "./components/ourResources";
import HomepageBanner from "./components/homepageBanner";
import OurProjects from "./components/ourProjects";

import { closeLoader, openLoader } from "../../store/loader/loaderReducer";
import CitiisValues from "../WhoWeAre/components/CitiisValues";

const Home = () => {
  const dispatch = useDispatch();
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  const [whatiscitiisdata, setWhatiscitiisdata] = useState();
  const [ourworkdata, setOurworkdata] = useState();

  useEffect(() => {
    localStorage.removeItem("frombtn");
    localStorage.removeItem("citiisval");
  }, []);

  useEffect(() => {
    dispatch(openLoader());
    axios({
      url: "https://citiis.niua.in/web/citiis/api/v1/homepage-banner",
      method: "get",
    })
      .then((res) => {
        console.log("homebannerdata", res.data?.data);
        setWhatiscitiisdata(res.data?.data?.list?.WhatisCITIIS);
        setOurworkdata(res.data?.data?.list?.Ourwork);
        // setData(res.data?.data);
        dispatch(closeLoader());
      })
      .catch((err) => {
        console.log(err);
        dispatch(closeLoader());
      });
  }, []);
  return (
    <Paper elevation={0} className="homepagemainappdiv">
      <HomepageBanner />
      <WhatIsCitiis whatiscitiisdata={whatiscitiisdata} />
      {/* <OurWork ourworkdata={ourworkdata} /> */}
      <CitiisValues backgroundInverse />
      <CitiisDifferent />
      <OurProjects />
      <OurResources />
    </Paper>
  );
};

export default Home;
